import { BrowserRouter, Routes, Route } from "react-router-dom";

import TaskTools from "./page/TaskTools/TaskTools";
import Summary from "./page/Summary/Summary";
import CreateTask from "./page/CreateTask/CreateTask";
import Home from "./page/Home/Home";
import Signup from "./page/Signup/Signup";
import Onboarding from "./page/Onboarding/Onboarding";
import TaskManagement from "./Herosecetion/TaskManagement";
import SequFlowLanding from "./page/SequFlowLanding/SequFlowLanding";
import Listpage from "./page/Listpage/Listpage";
import Timeline from "./page/Timeline/Timeline";
import Calendar from "./page/Calendar/Calendar";
import Login from "./page/Login/Login";
import Forgot from "./page/Forgot/Forgot";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSecurityActions } from "./hooks/useSecurityActions";

function App() {
  useSecurityActions();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/sequflowlanding" element={<SequFlowLanding />} />

        <Route path="/tasks" element={<TaskTools />} />
        <Route path="/summary" element={<Summary />} />
        <Route path="/createtask" element={<CreateTask />} />
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/task-management" element={<TaskManagement />} />
        <Route path="/listpage" element={<Listpage />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />


      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  );
}
export default App;
